export default __webpack_public_path__ + "static/media/close-icon.0c747b26.svg";